import styled from 'styled-components';

export const InputPanel = styled.div`
  display: flex;
  align-items: center;
`;
